module.exports = __webpack_public_path__ + "media/library_item_types/work_order-11ebeb9b.png";